import axios from 'axios';

export { getUserInformation, getAccountInformation, updateUserDetails, redactUser };

async function getAccountInformation(accountId) {
  const response = await axios.get("/api/getAccountDetails", {
    params: {
      accountId,
    },
  });
  return response.data;
}

async function getUserInformation(userId) {
  const response = await axios.get("/api/getUserDetails", {
    params: {
      userId,
    },
  });
  return response.data.user;
}

async function updateUserDetails(userId, updatingUserDetails) {
  const payload = {
    editedUserId: userId,
    ...updatingUserDetails,
  };
  return axios.put("/api/saveUserDetails", payload);
}

async function redactUser(userId) {
  return axios.post("/api/redact/user", { userRemovedId: userId });
}
